import { z } from 'zod';

import { parseOrThrow } from '../../../api';
import { languageChoiceOf } from '../../../i18n/languages';

const userProfileSchema = z.object({
  name: z.string().default(''),
  number: z.string().nullable().default(null),
  email: z.string().nullable().default(null),
  language: z.string().nullish().transform(languageChoiceOf),
  isPhoneNumberVerified: z.boolean().default(false),
  isEmailAddressVerified: z.boolean().default(false),
  passwordSet: z.boolean().optional(),
});
export type UserProfileDto = z.infer<typeof userProfileSchema>;

export const userDetailsSchema = z.object({ user: userProfileSchema });

export const passwordChangeResultSchema = z.object({
  success: z.boolean(),
  code: z.string().nullish(),
  message: z.string().default(''),
});

export const languageSavedSchema = z.object({
  success: z.boolean(),
  message: z.string().default(''),
});

export { parseOrThrow };
